import styled from '@emotion/styled';

const StyledCampaignDescription = styled.div(
  {
    marginBottom: 26
  },
  ({ theme }) => ({
    color: theme.palette.colors.midnightBlue
  })
);

export default StyledCampaignDescription;
